export function validateEmail(email: string): boolean {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function validateURL(url: string): boolean {
  const re =
    /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;
  return re.test(String(url));
}

export interface ParsedEmail {
  email: string;
  valid: boolean;
}

/**
 * Splits a comma/space/newline-separated text blob into validated email entries.
 */
export function emailTextToList(text: string): ParsedEmail[] {
  if (!text || text.trim() === "") return [];
  const emailText = text.trim();
  return emailText
    .replace(/\n/, ",")
    .split(/[ ,]+/)
    .map((email) => ({
      email: email.toLowerCase(),
      valid: validateEmail(email),
    }));
}
